<template>
    <div id="parts">
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >PARTS INFORMATION
            <div style="float: right;">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="grey lighten-5"
                            fab
                            v-on="on"
                            target="_blank"
                            x-small
                            class="mb-1"
                            @click="
                                showpart(detailcase.maincase_id),
                                    (dialogpart = true)
                            "
                        >
                            <v-icon color="primary" small>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <span>View Detail</span>
                </v-tooltip>
            </div>
        </v-alert>

        <div style="margin-left:95%;"></div>
        <v-row justify="center">
            <v-dialog
                v-model="dialogpart"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary" data-v-f3f3eg9>
                        <v-btn icon dark @click="dialogpart = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Part </v-toolbar-title>

                        <v-spacer> </v-spacer>
                    </v-toolbar>
                    <v-alert>
                        <v-container fluid>
                            <div v-for="(row, i) in datapart" :key="i">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-actions>
                                                <v-row>
                                                    <v-col cols="12"
                                                        ><b>Recommend Part : </b
                                                        >{{
                                                            row.recommend_part_name
                                                        }}
                                                        |
                                                        {{
                                                            row.recommend_part_desc
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Recommend Date : </b
                                                        >{{
                                                            row.recommend_date_x
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Recommend By : </b
                                                        >{{
                                                            row.recommend_by_x
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12"
                                                        ><b>Issue Part : </b>
                                                        {{
                                                            row.issue_part_name
                                                        }}
                                                        |
                                                        {{
                                                            row.issue_part_desc
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Issue Date : </b
                                                        >{{ row.issue_date_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Issue By : </b>
                                                        {{ row.issue_by_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Singlepart : </b
                                                        >{{ row.singlepart }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Ship Date : </b
                                                        >{{ row.ship_date_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Packing Date : </b
                                                        >{{ row.packing_date }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Packing No : </b
                                                        >{{ row.packing_no }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Onhand Date : </b
                                                        >{{ row.onhand_date_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="8"
                                                        ><b>Onhand By : </b
                                                        >{{ row.onhand_by_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b
                                                            >Engineer Status : </b
                                                        >{{ row.ce_status }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>SN Issue : </b
                                                        >{{ row.issue_sn }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Serial Return : </b
                                                        >{{ row.issue_sn }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Return Date : </b
                                                        >{{
                                                            row.ce_return_date_x
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="8"
                                                        ><b>Return By : </b
                                                        >{{
                                                            row.ce_return_by_x
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Receive Date : </b
                                                        >{{
                                                            row.receive_date_x
                                                        }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Receive By : </b
                                                        >{{ row.receive_by_x }}
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                        ><b>Receive SN : </b>
                                                        {{ row.receive_sn }}
                                                    </v-col>
                                                </v-row>
                                            </v-card-actions>
                                        </v-card>
                                    </v-col></v-row
                                >
                            </div></v-container
                        >
                    </v-alert>
                    <!-- <v-list
                        style="border:2px solid black;"
                        three-line
                        subheader
                        v-for="(datapart1, i) in datapart"
                        :key="i"
                        ><v-row>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Eta :
                                            </label>
                                            {{ datapart1.eta }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Ct_Old :
                                            </label>
                                            {{ datapart1.ct_old }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Ct_New :
                                            </label>
                                            {{ datapart1.ct_new }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-70px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Recommend_Desc:</label
                                            >
                                            {{ datapart1.recommend_part_desc }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Recommend_By/Date:</label
                                            >
                                            {{ datapart1.recommend_by_x }}
                                            {{ datapart1.recommend_date_x }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-50px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Singlepart :</label
                                            >
                                            {{
                                                datapart1.singlepart
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >RMA :</label
                                            >
                                            {{
                                                datapart1.rma
                                            }}</v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >PoNumber :</label
                                            >
                                            {{
                                                datapart1.ponumber
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-70px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Issue_Desc :</label
                                            >
                                            {{
                                                datapart1.issue_part_desc
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Issue_Serial :</label
                                            >
                                            {{
                                                datapart1.issue_sn
                                            }}</v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Issue_By/Date :</label
                                            >
                                            {{ datapart1.issue_by_x }}<br />
                                            <label style="margin-left:110px;"
                                                >{{ datapart1.issue_date_x }}
                                            </label> </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-70px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Ship_Date :</label
                                            >
                                            {{
                                                datapart1.ship_date_x
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Is_Backorder :</label
                                            >
                                            {{
                                                datapart1.is_backorder
                                            }}</v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Onhand_By/Date :</label
                                            >
                                            {{ datapart1.onhand_by_x }}<br />
                                            <label style="margin-left:110px;"
                                                >{{ datapart1.onhand_date_x }}
                                            </label> </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-70px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Ce_Status :</label
                                            >
                                            {{
                                                datapart1.ce_status
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Ce_ReturnBy/Date :</label
                                            >
                                            {{ datapart1.ce_return_by_x }}<br />
                                            <label style="margin-left:140px;"
                                                >{{
                                                    datapart1.ce_return_date_x
                                                }}
                                            </label></v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label
                                                style="font-weight:bold;"
                                            ></label> </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:-70px;">
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Return_No :</label
                                            >
                                            {{
                                                datapart1.return_no
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label style="font-weight:bold;"
                                                >Receive_Sn :</label
                                            >
                                            {{
                                                datapart1.receive_sn
                                            }} </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                            <v-col cols="4">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label
                                                style="font-weight:bold;"
                                            ></label> </v-list-item-title
                                        ><v-list-item-content>
                                        </v-list-item-content>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list> -->
                    <v-divider></v-divider>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- <v-alert>
            <v-card-text>
                
            </v-card-text>
        </v-alert> -->
        <v-row>
            <v-col cols="12">
                <!-- <v-data-table
                            :headers="headers"
                            :items="this.detailcase.parts"
                            :items-per-page="10"
                            :loading="isLoading"
                            :search="search"
                            loading-text="Loading... Please wait"
                        >
                        </v-data-table> -->
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th class="text-center">Sub</th>
                                <th class="text-center">Part</th>
                                <th class="text-center">Singlepart</th>
                                <th class="text-center">Serial Issue</th>
                                <th class="text-center">Serial Return</th>
                                <th class="text-center">Ship Date</th>
                                <th class="text-center">CE Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(row, index) in detailcase.parts"
                                :key="index"
                            >
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td class="text-center">
                                    <v-badge
                                        inline
                                        color="blue lighten-2"
                                        :content="row.subcase"
                                    >
                                    </v-badge>
                                </td>
                                <td>
                                    <strong>{{ row.part_name }}</strong>
                                    <v-chip
                                        v-if="row.status == 'Back Order'"
                                        x-small
                                        class="ml-2"
                                        color="red"
                                        style="color:white;"
                                        >{{ row.status }}</v-chip
                                    >
                                    <v-chip
                                        else
                                        x-small
                                        class="ml-2"
                                        color="green lighten-3"
                                        style="color:white;"
                                        >{{ row.status }}</v-chip
                                    >
                                    <br />
                                    <div
                                        class="font-weight-light"
                                        v-if="row.part_description"
                                    >
                                        <span
                                            v-if="
                                                row.part_description.length < 30
                                            "
                                        >
                                            {{ row.part_description }}
                                        </span>
                                        <span v-else>
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                    }"
                                                >
                                                    <span v-on="on">
                                                        {{
                                                            row.part_description.substring(
                                                                0,
                                                                30
                                                            ) + "..."
                                                        }}
                                                    </span>
                                                </template>
                                                <span>{{
                                                    row.part_description
                                                }}</span>
                                            </v-tooltip>
                                        </span>
                                    </div>
                                    {{ row.remark }}
                                </td>
                                <td>{{ row.singlepart }}</td>
                                <td>{{ row.issue_sn }}</td>
                                <td>{{ row.receive_sn }}</td>
                                <td>{{ row.ship_date_x }}</td>
                                <td>{{ row.ce_status }}</td>
                            </tr>
                            <br />
                        </tbody> </template
                ></v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"

export default {
    props: ["detailcase"],
    beforeMount() {},
    methods: {
        async showpart(value) {
            const url =
                `${process.env.VUE_APP_ROOT_API}/api/part-detail/` + value

            try {
                let { data } = await axios.get(url)
                this.datapart = data
            } catch (error) {
                console.log(error.message)
            }
        },
    },
    data() {
        return {
            datapart: [],
            dialogpart: false,
            dialog: false,
            classHead: "text-uppercase darken-3 black--text body-2",
            headers: [
                {
                    text: "Part Status",
                    value: "status",
                    class: this.classHead,
                },
                {
                    text: "Sub",
                    value: "subcase",
                    class: this.classHead,
                },
                {
                    text: "Part Description",
                    value: "part_description",
                    class: this.classHead,
                },
                {
                    text: "Singlepart",
                    value: "singlepart",
                    class: this.classHead,
                },
                {
                    text: "Serial Old",
                    value: "ct_old",
                    class: this.classHead,
                },
                {
                    text: "Serial New",
                    value: "ct_new",
                    class: this.classHead,
                },
                {
                    text: "CE Status",
                    value: "ce_status",
                    class: this.classHead,
                },
                {
                    text: "Actions",
                    value: "action",
                    class: this.classHead,
                },
            ],
        }
    },
}
</script>
